var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapviewimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0104 0.630354C4.13348 0.589361 4.26652 0.589361 4.3896 0.630354L7.8 1.76735L10.4202 0.893754C10.6006 0.833568 10.7927 0.817113 10.9807 0.845746C11.1687 0.874379 11.3472 0.947281 11.5015 1.05844C11.6558 1.1696 11.7814 1.31584 11.8681 1.4851C11.9548 1.65436 12 1.84179 12 2.03195V9.16775C12.0001 9.41964 11.9209 9.66517 11.7737 9.86956C11.6265 10.0739 11.4187 10.2268 11.1798 10.3066L7.9896 11.3698C7.86652 11.4107 7.73348 11.4107 7.6104 11.3698L4.2 10.2322L1.5792 11.1058C1.39885 11.1658 1.20681 11.1822 1.01889 11.1535C0.830979 11.1248 0.652568 11.0519 0.498357 10.9407C0.344145 10.8296 0.218545 10.6834 0.131902 10.5142C0.0452577 10.345 4.93025e-05 10.1576 3.48113e-08 9.96755V2.83175C-6.06367e-05 2.5798 0.079187 2.33421 0.226509 2.12981C0.373831 1.92541 0.581753 1.77257 0.8208 1.69295L4.0104 0.629754V0.630354ZM4.8 9.16775L7.2 9.96815V2.83175L4.8 2.03135V9.16775ZM3.6 2.03195L1.2 2.83235V9.96755L3.6 9.16715V2.03195ZM8.4 2.83235V9.96755L10.8 9.16715V2.03195L8.4 2.83235Z",
    fill: "#5C79AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapviewimage);
export default __webpack_public_path__ + "static/media/mapviewimage.0c4afe6849a73bb41d69b35436c18c34.svg";
export { ForwardRef as ReactComponent };